import http from '../utils/http-common';
import { AssistantChatInput } from '../types/api-response.type';

const config = {
  headers: {
    'Content-Type': 'multipart/form-data;',
  },
};

const headers = {
  Accept: 'application/json, text/plain, */*',
  'Content-Type': 'application/json',
};

const getAgent = (subDomainName: string) => {
  return http.post<any>(`${process.env.REACT_APP_API_URL}/public-agents/agent/fetch-agent`, { subDomainName });
};

// const addMsgsToThread = (input: AssistantChatInput) => {
//   return fetch(`${process.env.REACT_APP_API_URL}/adv/pc/chat-with-assistant`, {
//     method: 'POST',
//     headers,
//     body: JSON.stringify(input),
//   });
// };

const addMsgsToThread = (input: AssistantChatInput) => {
  return fetch(`${process.env.REACT_APP_API_URL}/public-agents/agent/chat-with-assistant`, {
    method: 'POST',
    headers,
    body: JSON.stringify(input),
  });
};

const createThread = () => {
  return http.get<any>(`${process.env.REACT_APP_API_URL}/adv/openai/create-thread`);
};

const validateMapleLMSToken = (token: string, subdomain: string) => {
  return http.get<any>(`${process.env.REACT_APP_API_URL}/public-agents/maple-lms/callback`, {
    params: { token, subdomain }
  });
};

const getChatsByUserId = (userId: string) => {
  return http.post<any>(`${process.env.REACT_APP_API_URL}/public-agents/agent/get-chats-by-user-id`, { userId });
};

const getPineconeSuggestions = (msg: string, orgId: string, assistantId?: string) => {
  return http.post<any>(`${process.env.REACT_APP_API_URL}/adv/chat-utils/get-suggestions-from-pinecone`, {
    msg,
    org_id: orgId,
    assistant_id: assistantId,
  });
};

const AgentService = {
  getAgent,
  addMsgsToThread,
  createThread,
  validateMapleLMSToken,
  getChatsByUserId,
  getPineconeSuggestions,
};

export default AgentService;
